// @ts-ignore

import React from 'react';
// import AntdDatePicker from '../AntdDatePicker/index';
import "./style.less";
var CalendarMonthTitle = function CalendarMonthTitle(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "date-picker-title-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-text"
  }, props.monthTitle), /*#__PURE__*/React.createElement("div", {
    className: "date-picker-title-date-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Su"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Mo"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Tu"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "We"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Th"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Fr"), /*#__PURE__*/React.createElement("span", {
    className: "date-picker-title-date-text"
  }, "Sa"))));
};
export default CalendarMonthTitle;